var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "catalog-sort" }, [
    _c(
      "button",
      {
        directives: [
          {
            name: "click-outside",
            rawName: "v-click-outside",
            value: function() {
              return (_vm.listOpen = false)
            },
            expression: "() => (listOpen = false)"
          }
        ],
        ref: "button",
        staticClass: "catalog-sort__btn btn btn--small",
        class: { "btn--bg": _vm.isSortActive },
        on: {
          click: _vm.toggleList,
          keydown: [
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.toggleList.apply(null, arguments)
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "space", 32, $event.key, [
                  " ",
                  "Spacebar"
                ])
              ) {
                return null
              }
              return _vm.toggleList.apply(null, arguments)
            }
          ]
        }
      },
      [
        _vm.isSortActive
          ? _c(
              "span",
              { staticClass: "catalog-sort__icon sort-dot for-mobile" },
              [_c("SortDotIcon", { attrs: { height: "20" } })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "catalog-sort__label" },
          [
            _vm._t("default", function() {
              return [_vm._v(_vm._s(_vm.selectedLabel))]
            })
          ],
          2
        ),
        _vm._v(" "),
        _vm.isSortActive
          ? _c(
              "span",
              { staticClass: "catalog-sort__sort-icon sort-swap for-mobile" },
              [_c("SortSwapIcon")],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.isSortActive
          ? _c(
              "span",
              { staticClass: "catalog-sort__sort-icon" },
              [_c("SortArrowIcon", { attrs: { width: "17", height: "18" } })],
              1
            )
          : _c(
              "span",
              { staticClass: "catalog-sort__icon for-desktop" },
              [
                _c("ArrowIcon", {
                  staticClass: "catalog-sort__arrow",
                  class: { "icon--rotate-180": _vm.orderDir === "asc" },
                  attrs: { height: "20" }
                })
              ],
              1
            )
      ]
    ),
    _vm._v(" "),
    !_vm.buttonOnly && _vm.listOpen
      ? _c(
          "div",
          {
            ref: "list",
            staticClass: "catalog-sort__list",
            class: { "is-visible": _vm.listOpen },
            attrs: { tabindex: "0", role: "listbox" },
            on: { keydown: _vm.onKeyDown }
          },
          [
            _vm._l(_vm.selectOptions, function(ref, index) {
              var key = ref.key
              var name = ref.name
              var direction = ref.direction
              return [
                _c(
                  "button",
                  {
                    key: key + "-" + direction,
                    staticClass: "catalog-sort__list-item btn--clear",
                    class: {
                      "is-active": _vm.currentOption === index
                    },
                    attrs: {
                      role: "option",
                      "aria-label": _vm.getSortAriaLabel(name, direction),
                      tabindex: "-1"
                    },
                    on: {
                      click: function($event) {
                        return _vm.setOrderByList(key, direction)
                      },
                      keydown: [
                        function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "space", 32, $event.key, [
                              " ",
                              "Spacebar"
                            ])
                          ) {
                            return null
                          }
                          return _vm.setOrderByList(key, direction)
                        },
                        function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.setOrderByList(key, direction)
                        }
                      ]
                    }
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "catalog-sort__list-label" },
                      [
                        name === "Price"
                          ? [_vm._v("Cena")]
                          : [_vm._v(_vm._s(name))],
                        _vm._v(" "),
                        !["position", "created_at"].includes(key)
                          ? _c("span", [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.i18n(
                                      direction === "desc"
                                        ? "descending"
                                        : "ascending"
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ])
                          : _vm._e()
                      ],
                      2
                    )
                  ]
                )
              ]
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }